<article class="customization">
    <section class="customizationMenu">
        <app-section-header title="Customization" iconName="configuration"> </app-section-header>
        <nav class="menu">
            <ul class="menuList">
                @for (item of menuItems; track item.id) {
                    <li class="menuItem">
                        <button
                            type="button"
                            role="tab"
                            class="tab"
                            [class.active]="selectedPath() === item.path"
                            [disabled]="hasUnsavedChanges()"
                            (click)="onNavigate(item.path)"
                        >
                            <span class="title">{{ item.tabName }}</span>
                            <span class="subtitle">{{ item.subtitle }}</span>
                        </button>
                    </li>
                }
            </ul>
        </nav>
    </section>
    <section class="customizationContent">
        <div class="content">
            @if (isFieldsView()) {
                <app-customization-custom-fields
                    [entityName]="selectedItem().tabName"
                    [entityTypeId]="selectedItem().id"
                    (hasUnsavedChanges)="onUnsavedChangesChange($event)"
                ></app-customization-custom-fields>
            } @else {
                <app-customization-custom-info
                    [entityName]="selectedItem().tabName"
                    [entityTypeId]="selectedItem().id"
                    (hasUnsavedChanges)="onUnsavedChangesChange($event)"
                ></app-customization-custom-info>
            }
        </div>
    </section>
</article>
